import { green, amber, red, blue, slate, emerald, gray } from './palette.js';

export const semantic = {
  success: green[500],
  successBg: green[50],
  successBorder: green[200],
  warning: amber[500],
  warningBg: amber[50],
  warningBorder: amber[200],
  error: red[600],
  errorBg: red[50],
  errorBorder: red[200],
  info: blue[500],
  infoBg: blue[50],
  infoBorder: blue[200],
  neutral: slate[500],
  online: emerald[500],
  offline: gray[400],
  idle: amber[500],
  busy: red[500]
} as const;

export type SemanticToken = keyof typeof semantic;
